/**
 * Common functionality for the DigitalEvent components
 */
import ModalWindow from "@/components/DigitalEvent/common/ModalWindow";
import ModalWindowLink from "@/components/DigitalEvent/common/ModalWindowLink";
import Preloader from "@/components/DigitalEvent/common/Preloader";
import { ROUTES, USER_STATUSES } from "@/helpers/constants";

export default {
  props: {
    // This property will be used on every page
    digitalEventSlug: String
  },
  components: {
    "modal-window": ModalWindow,
    "modal-window-link": ModalWindowLink,
    "digital-event-preloader": Preloader
  },
  data() {
    return {
      ROUTES: ROUTES,
      USER_STATUSES: USER_STATUSES
    };
  },
  methods: {
    /**
     * Got to route
     * @param routeName {String}
     * @param routeParams {Object}
     */
    goTo(routeName, routeParams = null) {
      let params = routeParams || {};
      params.digitalEventSlug = this.$store.state.event.context.SLUG;

      this.$router
        .push({
          name: routeName,
          params: params
        })
        .catch(() => {});
    },

    /**
     * Logout from DigitalEvent
     * @return {Promise<void>}
     */
    async logout() {
      if (this.$route.name.includes(this.ROUTES.DIGITAL_EVENT_AUTH)) {
        /**
         * In this case we logout from table-info component
         * And we don't load all necessary data in Auth component
         * That's why we need to load all data here: user and simple context
         */
        this.$store.commit("setPreloaderFlag", true);

        await this.goTo(ROUTES.DIGITAL_EVENT_AUTH_LOGIN);
        await this.$store.dispatch("logout");

        this.$store.commit("setPreloaderFlag", false);
      } else {
        /**
         * In this case we logout from Room component
         * And all necessary data will be loaded in main Auth component
         */
        await this.$store.dispatch("logout");
        this.$store.dispatch("socket/stopStatePulling");
        await this.goTo(ROUTES.DIGITAL_EVENT_AUTH_LOGIN);
      }
    }
  }
};
